import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Disclaimer from '../Disclaimer';
import PdfForm from '../PdfForm';
import ShareFrom from '../ShareForm';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view01ImageOptions } from './views/exterior_view01'

class XC45Summary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        };
    }

    render() {
        let imageOptions = exterior_view01ImageOptions;

        let image = (
            <TransomConfigurator colorMultiplier={0.75} name={this.props.configuration.transom.Name} port={this.props.configuration.transom.Port} transomSize={{ width: 1800, height: 785 }} transform={
                [
                    0.057062, -0.021958, 0, -0.000083,
                    0.019683, 0.118142, 0, 0.000024,
                    0, 0, 1, 0,
                    275, 373, 0, 1
                ]}>
                <ConfiguratorImage boat="XC45" configuration={this.props.configuration.exterior} options={imageOptions} />
            </TransomConfigurator>
        );



        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>
                    <h1><Trans defaults='Summary' /></h1>
                    <h2><Trans defaults='Congratulations!' /></h2>
                    <p><Trans defaults='You have now configured the basics of an Xc 45. If you want a full configuration of your boat, please contact your local X-Yachts Dealer.' /></p>
                 

                    <PdfForm boat="xc45" country={this.props.country} countries={this.props.countries} configuration={this.props.configuration} code={this.props.code} />


                    <ShareFrom configuration={this.props.configuration} boat="xc45" code={this.props.code} />
                    
                    <Disclaimer />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XC45Summary);


// WEBPACK FOOTER //
// ./src/XC45/XC45Summary.js